import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { communications } from '../../../constants/communications';
import CommunicationService from '../../../services/components/Communication';
import Notifications from '../../Notifications';

const CommunicationsProvider = ({ isCircle, isAuth }) => {
  const { pathname } = useLocation();

  const onAnalize = useCallback(
    ({ paths, variable, acceptCircle, activeFromDate, activeToDate }) => {
      const checkAuthConfig = () => isAuth;
      const checkShowCommunication = () =>
        CommunicationService.checkShowCommunication(
          variable,
          activeFromDate,
          activeToDate,
          acceptCircle,
          isCircle,
          pathname,
          paths,
        );

      return checkAuthConfig() && checkShowCommunication();
    },
    [pathname, isCircle, isAuth],
  );

  const saveVariable = (variable) => {
    CommunicationService.saveVariable(variable, true);
  };

  const onClose = ({ variable, customButtons }) => {
    if (!customButtons) {
      if (variable) {
        saveVariable(variable);
      }
    }
  };

  return (
    <Notifications
      onAnalize={onAnalize}
      onClose={onClose}
      config={communications}
      onSaveVariable={saveVariable}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    isCircle: state.auth?.authData?.isCircle,
    isAuth: state.auth.authData && !!Object.keys(state.auth.authData).length,
  };
};

export default connect(mapStateToProps, null)(CommunicationsProvider);
